import { Callout, HTMLTable, Spinner, Tag } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";

import { authenticatedGetFetch } from "../../../../utils/AuthenticatedFetch";

function performanceIntent(value) {
  if (value >= 85) return "success";
  else if (value >= 50) return "warning";
  else return "danger";
}

export default function ClassificationReliability(props) {
  const [perf, setPerf] = useState({});

  useEffect(() => {
    authenticatedGetFetch(
      "/ow/dc/perf/classification?" +
        new URLSearchParams({
          srv: props.srv,
          ...(props.from && { from: props.from }),
          ...(props.to && { to: props.to }),
        }),
      (perf) => setPerf(perf)
    );
  }, [props.srv, props.from, props.to]);

  return (
    <Callout
      icon="predictive-analysis"
      title={<Trans>reliability of classification data</Trans>}
    >
      {perf ? (
        <>
        <Callout intent="primary">
          <Trans>assesses the reliability of vehicle categorization by comparing data collected at parking lot entrances and exits for each vehicle.</Trans>
        </Callout>
        <HTMLTable striped={true} compact={true}>
          <thead>
            <tr>
              <td>
                <Trans>criteria</Trans>
              </td>
              <td>
                <Trans>success</Trans>
              </td>
              <td>
                <Trans>performance</Trans>
              </td>
            </tr>
          </thead>
          <tbody>
            {Object.entries(perf)?.map((crit) => (
              <tr>
                <td>
                  <Trans>{crit[0]}</Trans>
                </td>
                <td>
                  {crit[1].ok}/{crit[1].total}
                </td>
                <td>
                  <Tag
                    intent={performanceIntent(
                      (crit[1].ok / crit[1].total) * 100
                    )}
                  >
                    {((crit[1].ok / crit[1].total) * 100).toFixed(2)} %
                  </Tag>
                </td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
        </>
      ) : (
        <Spinner />
      )}
    </Callout>
  );
}
